export default "/assets/images/the-overreactor.27161a5068787c83.webp";